import { NavMenuEnum } from "src/library/types/types";

export const REGISTRATIONS_CLOSE_TIME = "2022-07-23T09:00:00";
export const EVENT_START_DATE = "2022-07-21T00:00:01";
export const HACKATHON_EMAIL_ADDRESS = "hackathon@entaingroup.com.au";

export const FORM_ENABLED = process.env.REACT_APP_FORM_ENABLED === "true";
export const INTRO_ENABLED = process.env.REACT_APP_INTRO_ENABLED === "true";
export const EVENT_INFORMATION_ENABLED =
  process.env.REACT_APP_EVENT_INFORMATION_ENABLED === "true";
export const CHALLENGES_PRIZES_ENABLED =
  process.env.REACT_APP_CHALLENGES_PRIZES_ENABLED === "true";
export const GUEST_SPEAKERS_ENABLED =
  process.env.REACT_APP_GUEST_SPEAKERS_ENABLED === "true";
export const PARTNERS_ENABLED = process.env.REACT_APP_PARTNERS_ENABLED === "true";
export const FAQ_ENABLED = process.env.REACT_APP_FAQ_ENABLED === "true";
export const TEASER_SITE_ENABLED = process.env.REACT_APP_TEASER_SITE === "true";

const navMenuItems: string[] = [
  NavMenuEnum.Home,
  NavMenuEnum.Event,
  NavMenuEnum.ChallengesPrizes,
  NavMenuEnum.Guests,
  NavMenuEnum.Partners,
  NavMenuEnum.Faq,
  NavMenuEnum.Contact,
];

const getLinksToShow = (arr: string[]) => {
  if (TEASER_SITE_ENABLED) {
    return (arr = arr.filter(
      (nav) => nav === NavMenuEnum.Home || nav === NavMenuEnum.Contact
    ));
  }
  if (!EVENT_INFORMATION_ENABLED) {
    arr = arr.filter((nav) => nav !== NavMenuEnum.Event);
  }
  if (!CHALLENGES_PRIZES_ENABLED) {
    arr = arr.filter((nav) => nav !== NavMenuEnum.ChallengesPrizes);
  }
  if (!GUEST_SPEAKERS_ENABLED) {
    arr = arr.filter((nav) => nav !== NavMenuEnum.Guests);
  }
  if (!PARTNERS_ENABLED) {
    arr = arr.filter((nav) => nav !== NavMenuEnum.Partners);
  }
  if (!FAQ_ENABLED) {
    arr = arr.filter((nav) => nav !== NavMenuEnum.Faq);
  }
  return arr;
};

export const NAV_MENU_ITEMS = getLinksToShow(navMenuItems);

export const ROUTE_MAP = new Map<string, string>();
